import React from 'react'
import PropTypes from 'prop-types'
import { CheckCircle, Cancel, Info } from '@mui/icons-material'
import Colors from 'utils/Colors'

import styles from './styles'

function BuildFlow(props) {
  const { item } = props

  const classes = styles()

  const returnColorComponent = (color) => {
    if (color === null || color === undefined)
      return <Info style={{ color: Colors.gray }} />
    return color ? (
      <CheckCircle style={{ color: Colors.green }} />
    ) : (
      <Cancel style={{ color: Colors.red }} />
    )
  }
  const returnStatusComponent = (status) => {
    if (status === null || status === undefined) return <span>Pendente</span>
    return status ? <span>Válido</span> : <span>Inválido</span>
  }

  return (
    <div className={classes.flow}>
      {item.status_document && (
        <div className={classes.rowItem}>
          <span>Documento</span>
          <div>
            <div>
              {returnColorComponent(item.status_document.document)}
              {returnStatusComponent(item.status_document.document)}
            </div>
            <div className={classes.document}>
              <span>
                {returnColorComponent(item.status_document.document_cpf)}
                <span>CPF </span>
              </span>
              <span>
                {returnColorComponent(item.status_document.document_name)}
                <span>Nome </span>
              </span>
              <span>
                {returnColorComponent(item.status_document.document_birthdate)}
                <span>Data de Nascimento </span>
              </span>
            </div>
            <div className={classes.attempts}>
              <span>{item.status_document.ocr_attempts}</span>
              <span>tentativa(s)</span>
            </div>
          </div>
        </div>
      )}
      {item.status_face && (
        <div className={classes.rowItem}>
          <span>Selfie</span>
          <div>
            <div>
              {returnColorComponent(item.status_face.liveness, false)}
              <span>Liveness</span>
            </div>
            <div>
              {returnColorComponent(item.status_face.facematch, false)}
              <span>Facematch</span>
            </div>
            <div className={classes.attempts}>
              <span>{item.status_face.liveness_attempts}</span>
              <span>tentativa(s)</span>
            </div>
          </div>
        </div>
      )}

      {item.quiz && (
        <div className={classes.rowItem}>
          <span>Quiz</span>
          <div>
            <div>
              {returnColorComponent(item.quiz.quiz_approved, false)}
              {returnStatusComponent(item.quiz.quiz_approved)}
            </div>
            <div className={classes.attempts}>
              <span>{item.quiz.quiz_attempts}</span>
              <span>tentativa(s)</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

BuildFlow.propTypes = {
  item: PropTypes.object.isRequired,
}

export default BuildFlow
